import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconCalendar = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M7.5 11.375H4.5C1.785 11.375 0.625 10.215 0.625 7.5V4.5C0.625 1.785 1.785 0.625 4.5 0.625H7.5C10.215 0.625 11.375 1.785 11.375 4.5V7.5C11.375 7.62 11.375 7.74499 11.365 7.85999C11.35 8.00999 11.245 8.14 11.1 8.185C10.955 8.23 10.795 8.18 10.7 8.06C10.345 7.625 9.82 7.375 9.25 7.375C8.825 7.375 8.41 7.52 8.08 7.785C7.63 8.14 7.375 8.67 7.375 9.25C7.375 9.815 7.625 10.345 8.06 10.7C8.18 10.795 8.225 10.955 8.185 11.1C8.14 11.245 8.015 11.35 7.86 11.365C7.745 11.375 7.62 11.375 7.5 11.375ZM4.5 1.375C2.195 1.375 1.375 2.195 1.375 4.5V7.5C1.375 9.805 2.195 10.625 4.5 10.625H7.00999C6.75999 10.22 6.625 9.745 6.625 9.25C6.625 8.44 6.98501 7.69501 7.61501 7.20001C8.45501 6.52001 9.73 6.46001 10.625 7.01001V4.5C10.625 2.195 9.805 1.375 7.5 1.375H4.5Z"
          fill={color}
        />
        <path
          d="M10.74 3.92999H1.26001C1.05501 3.92999 0.88501 3.75999 0.88501 3.55499C0.88501 3.34999 1.05501 3.17999 1.26001 3.17999H10.74C10.945 3.17999 11.115 3.34999 11.115 3.55499C11.115 3.75999 10.95 3.92999 10.74 3.92999Z"
          fill={color}
        />
        <path
          d="M4.26001 3.85999C4.05501 3.85999 3.88501 3.68999 3.88501 3.48499V1.05499C3.88501 0.849993 4.05501 0.679993 4.26001 0.679993C4.46501 0.679993 4.63501 0.849993 4.63501 1.05499V3.48499C4.63501 3.68999 4.46501 3.85999 4.26001 3.85999Z"
          fill={color}
        />
        <path
          d="M7.73999 3.63501C7.53499 3.63501 7.36499 3.46501 7.36499 3.26001V1.05499C7.36499 0.849993 7.53499 0.679993 7.73999 0.679993C7.94499 0.679993 8.11499 0.849993 8.11499 1.05499V3.26001C8.11499 3.47001 7.94999 3.63501 7.73999 3.63501Z"
          fill={color}
        />
        <path
          d="M9.25 11.875C8.64 11.875 8.05001 11.665 7.58501 11.28C6.97501 10.785 6.625 10.045 6.625 9.25C6.625 8.44 6.98501 7.69501 7.61501 7.20001C8.07501 6.83001 8.655 6.625 9.25 6.625C10.045 6.625 10.785 6.975 11.28 7.59C11.66 8.05 11.875 8.64 11.875 9.25C11.875 9.995 11.55 10.715 10.985 11.22C10.495 11.645 9.88 11.875 9.25 11.875ZM9.25 7.375C8.825 7.375 8.41 7.52 8.08 7.785C7.63 8.14 7.375 8.67 7.375 9.25C7.375 9.815 7.625 10.345 8.06 10.7C8.74 11.265 9.79501 11.26 10.49 10.655C10.89 10.295 11.125 9.78 11.125 9.25C11.125 8.815 10.975 8.395 10.7 8.065C10.345 7.625 9.815 7.375 9.25 7.375Z"
          fill={color}
        />
        <path
          d="M8.68989 10.19C8.56489 10.19 8.43988 10.125 8.36988 10.01C8.26488 9.83001 8.31989 9.59999 8.49989 9.495L9.01989 9.185V8.55499C9.01989 8.34999 9.18989 8.17999 9.39489 8.17999C9.59989 8.17999 9.76989 8.34999 9.76989 8.55499V9.39999C9.76989 9.52999 9.69988 9.655 9.58988 9.72L8.88488 10.14C8.81988 10.17 8.75489 10.19 8.68989 10.19Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default IconCalendar;
